import React, { useEffect, useCallback} from "react"
import useHistoryState from "../useHistoryState"
import { useSelector } from "react-redux"
import {  RootReducer } from "../app/reducer"

export type OptionCl = { id: string, description: string } 

 type Props = {
    id? : string
    name: string
    label?: string    
    countryOfTax?: OptionCl[]
    fatca?: OptionCl[]
    taxSpec?: OptionCl[]
    reset?:number 
}

export const InputTaxable : React.FC<Props> = props  => {    
    const windowHistoryState : any = useSelector((state:RootReducer) =>  state.securityResultReducer.secWindowHistoryState );
    const countriesOfTax = props.countryOfTax ? props.countryOfTax : []        
    const taxSpecificities = props.taxSpec ? props.taxSpec : []            

    //Set Initial state of the component
    const initialState = {disabled: true, checkedTaxable: false, taxaCtryValue: "Any", taxSpecValue: "Any"};    
    const [state, setState] = useHistoryState(props.name, initialState);

    useEffect(() => {        
        if (props.reset !== 0) {       
            setState(initialState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.reset])    

    //The below useEffect is used to maintain history when moving between pages
    useEffect(() => {                               
        if (windowHistoryState && windowHistoryState[props.name]) {
            setState(windowHistoryState[props.name]);
        }
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowHistoryState])

    const handleTaxable = useCallback(() => {       
        setState( { disabled: ! state.disabled, checkedTaxable: ! state.checkedTaxable, taxaCtryValue: state.taxaCtryValue, taxSpecValue: state.taxSpecValue } 
                )
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[state]);

    return(                
        <>
            <div className="search-table-row">
                <span className="search-table-col-left"> {props.label} </span>
                <span className="search-table-col-right-grid-taxable">
                    <span className="search-table-col-right-grid-item1"> 
                        <input id={props.id + "Check"} name= "taxable" type="checkbox" checked={state.checkedTaxable} onClick={handleTaxable} />                                  
                    </span>
                    <span className="search-table-col-right-grid-item2"> 
                        Country of tax :
                    </span>
                    <span className=".search-table-col-right-grid-item3"> 
                    <select id={props.id + "CountryOfTax"} name="taxCtry" disabled = {state.disabled} value={state.taxaCtryValue} onChange={ e => setState({...state, taxaCtryValue: e.target.value}) }>
                        {<option key={`---any${props.name}`} value="---">Any</option>}                    
                        {countriesOfTax.map( ctryOfTax => <option key={ctryOfTax.id+ctryOfTax.description} value={ctryOfTax.id}> {ctryOfTax.description} </option>)}
                    </select>   
                    </span>
                </span>
            </div>

            <div className="search-table-row">
                <span className="search-table-col-left">
                    Tax Specificity : 
                </span>
                <span className="search-table-col-right">
                    <select id={props.id + "TaxSpec"} name="taxSpecificity" disabled = {state.disabled} value={state.taxSpecValue} onChange={e => setState({...state, taxSpecValue: e.target.value})}>
                        {<option key={`---any${props.name}`} value="---">Any</option>}
                        {taxSpecificities.map( taxSpec => <option key={taxSpec.id+taxSpec.description} value={taxSpec.id}> {taxSpec.description} </option>)}
                    </select>
                </span>
            </div>
        </>        
    )
}
